import TextField from "@mui/material/TextField"
import TextMask, { maskCpf } from "Components/TextMask"

export default function InputCpf({...props}) {

    return <TextField
        InputProps={{
            inputComponent: TextMask
        }}
        inputProps={maskCpf}

        {...props}
        
    />
}